import { HttpHeaders } from '@angular/common/http';
export const endpoint = {
  //AUTH_MODULE
  LOGIN: 'auth/login',
  LOGOUT: 'auth/logout',
  ME: 'auth/me',
  //EMPLOYEE_MODULE
  CREATE_WORKER: 'worker/store',
  GET_WORKERS: 'worker',
  GET_WORKER_BY_ID: 'worker',
  UPDATE_WORKER_PROFILE: 'worker',
  UPDATE_WORKER_GUARANTORS: 'worker',
  UPDATE_WORKER_SKILLS: 'worker',
  UPDATE_WORKER_AVAILABILITY: 'worker',
  UPDATE_WORKER_OCCUPATIONS: 'worker',
  DELETE_WORKER: 'worker', // DELETE worker/:id
  GET_WORKER_DOCUMENTS: 'worker', // GET worker/:id/docs
  SHOW_WORKER_DOCUMENT: 'worker/document', // GET worker/document/:id
  UNBAN_WORKER: 'worker/unban', // PATCH worker/unban/:id

  //EMPLOYER_MODULE
  GET_EMPLOYERS: 'employers',
  GET_EMPLOYERS_BY_ID: 'employers',
  CREATE_EMPLOYER: 'employers',
  VERIFY_EMPLOYER_DOCUMENT: 'employer-documents', // POST employer-documents/:id/verify
  GET_EMPLOYER_DOCUMENTS: 'employers', // GET employers/:id/docs
  SHOW_EMPLOYER_DOCUMENT: 'employers/document', // GET employers/document/:id
  UNBAN_EMPLOYER: 'employers/unban', // GET employers/unban/:id

  //OCCUPATION_MODULE
  GET_OCCUPATIONS: 'occupation',
  CREATE_OCCUPATION: 'occupation',
  UPDATE_OCCUPATION: 'occupation',
  SHOW_OCCUPATION: 'occupation',
  DELETE_OCCUPATION: 'occupation',

  //ZONE_MODULE
  GET_ZONES: 'zone',
  CREATE_ZONE: 'zone',
  UPDATE_ZONE: 'zone',
  SHOW_ZONE: 'zone',
  DELETE_ZONE: 'zone',

  //JOBS_MODULE
  GET_JOB_POSTS: '/job-posts',
  CREATE_JOB_POST: '/job-posts',
  GET_JOB_POST_BY_ID: '/job-posts',

  //PERMISSIONS_MODULE
  GET_PERMISSIONS: 'permissions', // GET permissions?page=1
  CREATE_PERMISSION: 'permissions',
  UPDATE_PERMISSION: 'permissions', // PUT permissions/:id

  //ROLES_MODULE
  GET_ROLES: 'roles', // GET roles?page=1
  CREATE_ROLE: 'roles',
};
export const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};
